import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { SectionWrapper } from 'common/baseComponents';
import { ReactComponent as IconImages } from 'common/images/icon-images.svg'
import { GeneralContainer, IconContainer, SubText, ViewLabel, IconWrapper, MessageDiv } from './styles';
import { Information } from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { serviceLoading } from 'common/loaderReducer';
import { GET_LMIMAGES_API_REQUEST, POST_LMIMAGES_API_REQUEST } from 'features/Dealers/Listings/Images/state/actionTypes';
import ViewImages from './ViewImages';
import { ReactComponent as IconGreen } from 'common/images/icon-tick-green.svg'
import { ReactComponent as IconYellow } from 'common/images/icon-warning-yellow.svg'
import EditImages from 'features/Dealers/Listings/Images/EditImages';
import { getLMImagesAPI, postLMImagesAPI } from 'features/Dealers/Listings/Images/state/actions';
import { LMMediadata, LMimages } from 'features/Dealers/Listings/Images/state/types';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { ListingSyncErrorsUI } from 'features/Dealers/Listings/state/types';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';
import { getSyncError } from 'features/Dealers/Listings/utils'
import { getEnginePerPackage } from 'common/utils';
import { getUrlUpgradeAPI } from 'features/Home/Modals/UpsellUpgrade/state/actions';


interface LMImagesProps {
    isLoading: boolean
    isSaving: boolean
    originalimages?: LMimages
    selectedDealer?: Dealer
    listingSyncErrors?: ListingSyncErrorsUI
    selectedDealerId?: string,
    selectedListingId?: string,
    urlupgrade?:string
}

const Images = () => {
    const dispatch = useDispatch();
    const [firstLoad, setFirstLoad] = React.useState(true)
    const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);
    const [liveImages, setLiveImages] = React.useState<LMMediadata[]>([])

    const {
        isLoading,
        isSaving,
        originalimages,
        selectedDealer,
        listingSyncErrors,
        selectedDealerId,
        selectedListingId,
        urlupgrade
    }: LMImagesProps = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_LMIMAGES_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_LMIMAGES_API_REQUEST]),
            originalimages: rootState.dealers.listing.currentListing.images.dealerImages,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            urlupgrade: rootState.dealers.urlUpgrade.url
        }
    }, shallowEqual);


    React.useEffect(() => {
        if (!urlupgrade && selectedDealerId) {
            dispatch(getUrlUpgradeAPI(selectedDealerId))
        }
    }, [urlupgrade])

    React.useEffect(() => {
        if (editingState === InputIconFieldState.EDIT) {
            setLiveImages(originalimages?.mediadata ?? [])
        }
    }, [editingState])

    React.useEffect(() => {
        if (selectedListingId && selectedListingId != "") {
            dispatch(getLMImagesAPI(selectedListingId))
        }
    }, [selectedListingId])

    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId && originalimages) {
            if(allValid(originalimages.validationdata))
            {
                setEditingState(InputIconFieldState.VIEW)
                dispatch(getListingSyncErrors(selectedListingId??""));
                dispatch(getDealerListingsWithErrors(selectedDealerId??""));
            }
            else
            {
                setLiveImages(originalimages?.validationdata ?? [])
            }
        }
        setFirstLoad(false);
    }, [isSaving]) 

    const { alertTitle, alertMessage, iconType } = React.useMemo(() => {
        if (originalimages && originalimages?.count > originalimages?.minrecommended) {
            return {
                alertTitle: `You currently have ${originalimages?.count} photos in Google Business Profile`,
                alertMessage: `You are doing great, Google recommends to have between ${originalimages?.minrecommended}-${originalimages?.maxrecommended} images.`,
                iconType: <IconGreen />
            }
        }
        return {
            alertTitle: originalimages?.count === 0 ?
                `You don't have any photos added. Start by adding some`
                :
                `You have ${originalimages?.count} ${originalimages?.count && originalimages?.count > 1 ? "photos" : "photo"} in GBP, try adding a few more here.`,
            alertMessage: ` Google recommends to have between ${originalimages?.minrecommended}-${originalimages?.maxrecommended} photos. \n Follow Google best practices by adding more photos.`,
            iconType: <IconYellow />
        }
    }, [originalimages])

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return null;
    }

    return (
        <GeneralContainer>
            <SectionWrapper>
                <InputIconField
                    label={'Images'}
                    state={isSaving ? InputIconFieldState.LOADING : editingState}
                    renderValue={renderImages}
                    renderIcon={() => { return (<IconContainer><IconImages /></IconContainer>) }}
                    showAlertIcon={getSyncError('media',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('media',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('media',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('media',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldImgActionClick(action) }}
                    disabled={false}
                    disableBackground={true}
                />
            </SectionWrapper>
        </GeneralContainer>
    )

    function allValid(mediaData?: LMMediadata[]){
        if(mediaData?.find(obj => {
            return (obj.validation && obj.validation.length>0);
        })==undefined)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    function renderImages() {
        return (
            <>
                <ViewLabel>
                    {
                        alertTitle
                    }
                    {
                        editingState !== InputIconFieldState.EDIT &&
                        <MessageDiv>
                            <IconWrapper>
                                {
                                    iconType
                                }
                            </IconWrapper>
                            <SubText>
                                {
                                    alertMessage
                                }
                            </SubText>
                        </MessageDiv>
                    }
                </ViewLabel>
                {
                    selectedDealer && editingState === InputIconFieldState.EDIT ?
                        <EditImages
                            dealer={selectedDealer}
                            images={liveImages}
                            mediacategories={originalimages?.mediacategories!}
                            onImagesChange={onImagesChange}
                            informationMessages={originalimages?.informationMessages!}
                            url={urlupgrade}
                        />
                        :
                        originalimages && originalimages.mediadata && <ViewImages images={originalimages.mediadata} informationMessages={originalimages?.informationMessages!} coverPhotoMessage={selectedDealer?.lmPackage === "ELITE"? 'COVER_ELITE' : 'COVER'} otherPhotosMessage={selectedDealer?.lmPackage === "ELITE"? 'OTHERS_ELITE' : 'OTHERS'}/>
                }
            </>
        )
    }

    function onFieldImgActionClick(action: InputIconFieldAction) {
        switch (action) {
            case InputIconFieldAction.SAVE:
                {
                    if (selectedListingId) {
                        const engineId = getEnginePerPackage(selectedDealer?.lmPackage); 
                        dispatch(postLMImagesAPI(selectedListingId, liveImages, engineId ))
                    }
                    break;
                }
            case InputIconFieldAction.EDIT:
                {
                    setEditingState(InputIconFieldState.EDIT)
                    break;
                }
            case InputIconFieldAction.CANCEL:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    break;
                }
        }
    }

    function onImagesChange(newImages) {
        setLiveImages(newImages)
    }
}

export default Images

